import { emptyGuid, anyGuid } from './constants';

const filterOnPositionTemplate = (position, positionTemplateId) =>
  positionTemplateId === anyGuid ||
  (positionTemplateId === emptyGuid &&
    (!position.positionTemplateId || position.positionTemplateId === '')) ||
  position.positionTemplateId === positionTemplateId;

const filterOnPositionType = (position, positionType) =>
  positionType === anyGuid || position.positionType === positionType;

const filterOnCounterparty = (position, counterparty) =>
  counterparty === anyGuid || position.counterparty === counterparty;

const filterOnPortfolio = (position, portfolio) =>
  portfolio === anyGuid ||
  (position.portfolios !== undefined &&
    position.portfolios !== null &&
    position.portfolios.includes(portfolio));
export const filterPositions = (
  positions,
  positionTemplateId,
  positionType,
  counterparty,
  portfolio
) =>
  positions.filter(
    position =>
      filterOnPositionTemplate(position, positionTemplateId || emptyGuid) &&
      filterOnPositionType(position, positionType || anyGuid) &&
      filterOnCounterparty(position, counterparty || anyGuid) &&
      filterOnPortfolio(position, portfolio || anyGuid)
  );
